// Named "UserDocument" to avoid conflict with browser "Document" type

export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB

export enum DocumentStatus {
  pending = 'pending',
  uploaded = 'uploaded',
}

// FE only
export enum UploadStatus {
  pending = 'pending',
  uploading = 'uploading',
  uploaded = 'uploaded',
  failed = 'failed',
}

export interface UserDocument {
  id: string;
  name: string;
  status: DocumentStatus;
  mimeType?: string;
  fileSizeBytes?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface GenerateUploadUrlRequest {
  fileName: string;
  contentType: string;
}

export interface GenerateUploadUrlResponse {
  document: UserDocument;
  uploadUrl: string;
}

export interface ConfirmUploadRequest {
  fileSizeBytes: number;
}

export interface ConfirmUploadResponse {
  document: UserDocument;
}

export interface DocumentWithSignedUrl extends UserDocument {
  signedUrl?: string;
}

export interface UploadProgress {
  documentId: string;
  fileName: string;
  progress: number;
  status: UploadStatus;
  error?: string;
  file?: File; // Store original file for retry
}
